import {cn} from "@/lib/utils.ts";


export function PageWrapper(props) {
    return (
        <div>
            <div className={cn("relative font-normal px-9 py-9 space-y-6 max-w-[1350px] w-full mx-auto")}>
                {props.children}
            </div>
        </div>
    )
}